import type { ProductTaxonomyRenameDefinition } from '../types';

export const profilesRename = {
  terms: {
    people: {
      current: {
        singular: 'person',
        plural: 'people',
        titleSingular: 'Person',
        titlePlural: 'People',
      },
      future: {
        singular: 'profile',
        plural: 'profiles',
        titleSingular: 'Profile',
        titlePlural: 'Profiles',
      },
    },
    // "Customer(s)" is used interchangeably with "People" for the audience noun today; the rename
    // standardizes both on "Profile(s)". Same future forms as `people`, distinct current forms so
    // flag-off output stays byte-identical.
    customers: {
      current: {
        singular: 'customer',
        plural: 'customers',
        titleSingular: 'Customer',
        titlePlural: 'Customers',
      },
      future: {
        singular: 'profile',
        plural: 'profiles',
        titleSingular: 'Profile',
        titlePlural: 'Profiles',
      },
    },
  },
  copy: {
    'nav.manageAudience.people': {
      term: 'people.titlePlural',
    },
    // Relative pronoun for the people noun: "people who match" reads naturally, but once renamed a
    // profile is a thing, not a person, so it becomes "profiles that match". Compose this after the
    // people term in copy like `{people.plural} {people.relativePronoun} match`.
    'people.relativePronoun': {
      current: 'who',
      future: 'that',
    },
    // Doubled-noun guard: "customer profiles" must NOT become "profile profiles".
    // Flag-off: "Enrich your customer profiles" → flag-on: "Enrich your profiles"
    'home.enrichProfilesCardTitle': {
      current: 'Enrich your customer profiles',
      future: 'Enrich your profiles',
    },
    // Display value for the "Use Customer Zone" boolean field in audit logs
    'auditLogs.useCustomerTimezoneTitle': {
      current: 'Use Customer Timezone',
      future: 'Use Profile Timezone',
    },
    // Billing uses the compound "people profiles" / "People Profiles" today; under the rename a
    // profile already implies a person, so it collapses to just "profiles" / "Profiles" rather than
    // the doubled "profiles profiles". Used by the Your Plan usage/messaging displays.
    'billing.profilesUnit': {
      current: 'people profiles',
      future: 'profiles',
    },
    'billing.profilesUnitTitle': {
      current: 'People Profiles',
      future: 'Profiles',
    },
    // "Billable People Count" / "Billable Profile Count" in the billing-help sidebar. Singular, because
    // it qualifies "Count" rather than standing alone. Mirrors Ember's key of the same name.
    'billing.billableCountNoun': {
      current: 'People',
      future: 'Profile',
    },
  },
  routes: {
    'people.index': {
      current: '/workspaces/:workspaceId/journeys/people',
      future: '/workspaces/:workspaceId/journeys/profiles',
    },
  },
  sideNavItemIds: {
    people: 'profiles',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
